import api from "@/api/api.js";
import store from "@/store";

export const uris = {
  status: 'diagnostico/analise-qualitativa-estoque/status',
  segmentos: 'diagnostico/analise-qualitativa-estoque/status/segmentos',
  fornecedores: 'diagnostico/analise-qualitativa-estoque/status/fornecedores',
  produtos: 'diagnostico/analise-qualitativa-estoque/status/produtos',
};

export function buscarFiltros(linha = {}) {
  let parametros_linha = {};

  if (linha.idgrupo) {
    parametros_linha.grupos = [linha.idgrupo];
  }

  if (linha.idstatus) {
    parametros_linha.idstatus = linha.idstatus;
  }

  if (linha.idsegmento) {
    parametros_linha.segmentos = [linha.idsegmento];
    parametros_linha.idsegmento = linha.idsegmento;
  }

  if (linha.idfornecedor) {
    parametros_linha.fornecedores = [linha.idfornecedor];
    parametros_linha.idfornecedor = linha.idfornecedor;
  }

  if (linha.idproduto) {
    parametros_linha.produtos = [linha.idproduto];
    parametros_linha.idproduto = linha.idproduto;
  }

  if (linha.produto_combinado) {
    parametros_linha.produto_combinado = linha.produto_combinado ? 'S' : 'N';
  }

  return {
    ...store.getters["diagnosticoAnaliseQualitativaEstoque/filtrosGridPrincipal"],
    ...parametros_linha,
    ...store.getters['filtrosUniversalAvancado/filtros_formatados']
  };
}

function extrairFiltrosParaLinhasDeSubNiveis(linha) {
  let campos_extras = {};

  if (linha.idgrupo) {
    campos_extras.idgrupo = linha.idgrupo;
  }

  if (linha.idsegmento) {
    campos_extras.idsegmento = linha.idsegmento;
  }

  if (linha.idfornecedor) {
    campos_extras.idfornecedor = linha.idfornecedor;
  }

  if (linha.idproduto) {
    campos_extras.idproduto = linha.idproduto;
  }

  return campos_extras;
}

function adicionarFiltrosNivelAnteriorEmLinhas(linhas, linha) {
  const campos_extras = extrairFiltrosParaLinhasDeSubNiveis(linha);

  return linhas.map(item => ({
    ...campos_extras,
    ...item,
  }));
}

async function buscarStatus() {
  const params = buscarFiltros();
  return (await api.get(uris.status, {params})).data.status;
}

async function buscarSegmentos(linha) {
  const params = buscarFiltros(linha);
  const response = await api.get(uris.segmentos, {params});
  return adicionarFiltrosNivelAnteriorEmLinhas(response.data.segmentos, linha);
}

async function buscarFornecedores(linha) {
  if (linha.descricao_linha === 'COMBINADOS') {
    linha.produto_combinado = true;
    return await buscarProdutos(linha);
  }

  const params = buscarFiltros(linha);
  const response = await await api.get(uris.fornecedores, {params});
  return adicionarFiltrosNivelAnteriorEmLinhas(response.data.fornecedores, linha);
}

async function buscarProdutos(linha) {
  const params = buscarFiltros(linha);
  const response = await api.get(uris.produtos, {params});
  return response.data.produtos.map(item => ({
    ...item,
    $nao_expansivel: linha.produto_combinado,
  }));
}

export const lista_padrao_callbacks = [
  {
    id: 'status',
    descricao: "Status Análise",
    callback: buscarStatus,
  },
  {
    id: 'segmentos',
    descricao: "Segmentos",
    callback: buscarSegmentos,
  },
  {
    id: 'fornecedores',
    descricao: "Fornecedores",
    callback: buscarFornecedores,
  },
  {
    id: 'produtos',
    descricao: "Produtos",
    callback: buscarProdutos,
  },
];

